import { Component, OnInit } from '@angular/core';
import {ShareMetaSeoService} from "../../../../shared/services/share-meta-seo.service";
import {NavbarService} from "../../../../shared/services/navbar.service";
import {GalleryList} from "../../../../shared/entities/gallery-list";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'gryf-prints-and-stickers',
  templateUrl: './prints-and-stickers.component.html'
})
export class PrintsAndStickersComponent implements OnInit {

  images: GalleryList[] = [
    {
      url: 'assets/photos/services/prints_and_stickers/prints/print-1.jpg',
      title: 'Potlač na diár',
      alt: 'Potlač loga na diár.',
    },
    {
      url: 'assets/photos/services/prints_and_stickers/prints/print-2.jpg',
      title: 'Vzorkovník farieb',
      alt: 'Ponúkame možnosť tlačiť veľké spektrum farieb.',
    },
    {
      url: 'assets/photos/services/prints_and_stickers/prints/print-3.jpg',
      title: 'Papierová taška s potlačou',
      alt: 'Papierová taška s logom a vlastnou potlačom.',
    },
    {
      url: 'assets/photos/services/prints_and_stickers/prints/print-4.jpg',
      title: 'Potlač kalendáru',
      alt: 'Kalendár s logom firmy.',
    },
    {
      url: 'assets/photos/services/prints_and_stickers/prints/print-5.jpg',
      title: 'Reklamný kalendár',
      alt: 'Kalendár s logom firmy.',
    },
    {
      url: 'assets/photos/services/prints_and_stickers/stickers/stickers-1.jpg',
      title: 'Polep automobilu',
      alt: 'Reklamný polep automobilu.',
    },
    {
      url: 'assets/photos/services/prints_and_stickers/stickers/stickers-2.jpg',
      title: 'Polep dodávky',
      alt: 'Reklamný polep dodávky.',
    },
    {
      url: 'assets/photos/services/prints_and_stickers/stickers/stickers-3.jpg',
      title: 'Polep dodávky',
      alt: 'Reklamný polep dodávky.',
    }
  ];

  constructor(
    private share: ShareMetaSeoService,
    private navbarService: NavbarService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.share.updateSeoData(data.seo);
      this.share.createLinkForCanonicalURL();
    });

    this.navbarService.navbarInit();
  }

  ngOnDestroy(): void {
    this.navbarService.navbarDestroy();
  }

  closeNavBar(): void {
    document.getElementById('navbarCollapse').classList.remove('show');
  }

}
